<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import TemplateProdutoRequest from 'Modules/contacard/produto/templates/produto/ProdutoTemplateRequest';
import DataTableCurrencyColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import LocalSessionMixin from '@/app/arch/mixins/LocalSessionMixin';
import ProductTypeValueColumnVue from '../../product/components/columns/ProductTypeValueColumn.vue';
import ProductValueExpanselVue from './components/ProductValueExpansel.vue';
import ProductDebitCardValueTaxaColumnVue from './components/ProductDebitCardValueTaxaColumn.vue';
import ProductDebitCardValueBonusColumnVue from './components/ProductDebitCardValueBonusColumn.vue';
import ProductCreditCardValueBonusColumnVue from './components/ProductCreditCardValueBonusColumn.vue';
import ProductCreditCardValueTaxaColumnVue from './components/ProductCreditCardValueTaxaColumn.vue';
import ProductInstalltmentsCreditCardValueTaxaColumnVue from './components/ProductInstalltmentsCreditCardValueTaxaColumn.vue';
import ProductInstalltmentsCreditCardValueBonusColumnVue from './components/ProductInstalltmentsCreditCardValueBonusColumn.vue';
import ProductPixValueTaxaColumnVue from './components/ProductPixValueTaxaColumn.vue';
import ProductPixValueBonusColumnVue from './components/ProductPixValueBonusColumn.vue';
import ProductPrepaidValueBonusColumnVue from './components/ProductPrepaidValueBonusColumn.vue';
import ProductPrepaidValueTaxaColumnVue from './components/ProductPrepaidValueTaxaColumn.vue';

export default {
  name: 'TemplateProdutoList',
  extends: CrudListVue,
  mixins: [LocalSessionMixin],
  data: () => ({
    requestClass: TemplateProdutoRequest,
    editRoute: 'produtoTemplate.edit',
    showExpand: true,
    hideDelete: true,
    expandComponent: ProductValueExpanselVue,
    headers: [
      {
        text: 'Nome produto',
        value: 'produtoServico.nomProdutoServico',
        width: '15%',
      },
      {
        text: 'Tipo valor produto',
        value: 'produtoServico.tipoValorProduto',
        width: '10%',
        align: 'center',
        component: ProductTypeValueColumnVue,
      },
      {
        text: 'Valor fixo',
        value: 'produtoServico.vlrProdutoServico',
        width: '10%',
        align: 'center',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Valor mínimo',
        value: 'produtoServico.vlrVariavelMin',
        width: '10%',
        align: 'center',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Valor máximo',
        value: 'produtoServico.vlrVariavelMax',
        width: '10%',
        align: 'center',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Bônus (Débito)',
        value: 'valores',
        width: '10%',
        align: 'center',
        component: ProductDebitCardValueBonusColumnVue,
      },
      {
        text: 'Bônus (Crédito)',
        value: 'valores',
        width: '10%',
        align: 'center',
        component: ProductCreditCardValueBonusColumnVue,
      },
      {
        text: 'Bônus (Parcelado)',
        value: 'valores',
        width: '10%',
        align: 'center',
        component: ProductInstalltmentsCreditCardValueBonusColumnVue,
      },
      {
        text: 'Bônus (Pix)',
        value: 'valores',
        width: '10%',
        align: 'center',
        component: ProductPixValueBonusColumnVue,
      },
      {
        text: 'Bônus (Pré-pago)',
        value: 'valores',
        width: '10%',
        align: 'center',
        component: ProductPrepaidValueBonusColumnVue,
      },
      {
        text: 'Taxa (Débito)',
        value: 'valores',
        width: '10%',
        align: 'center',
        component: ProductDebitCardValueTaxaColumnVue,
      },
      {
        text: 'Taxa (Crédito)',
        value: 'valores',
        width: '10%',
        align: 'center',
        component: ProductCreditCardValueTaxaColumnVue,
      },
      {
        text: 'Taxa (Parcelado)',
        value: 'valores',
        width: '10%',
        align: 'center',
        component: ProductInstalltmentsCreditCardValueTaxaColumnVue,
      },
      {
        text: 'Taxa (Pix)',
        value: 'valores',
        width: '10%',
        align: 'center',
        component: ProductPixValueTaxaColumnVue,
      },
      {
        text: 'Taxa (Pré-pago)',
        value: 'valores',
        width: '10%',
        align: 'center',
        component: ProductPrepaidValueTaxaColumnVue,
      },
    ],
  }),
  computed: {
    getTemplateId() {
      return this.getSessionItem('templateId');
    },
  },
  methods: {
    prepareRequest(params) {
      return this.requestClass
        .list(
          this.prepareDefaultParams(params),
        );
    },
    prepareDefaultParams(params = {}) {
      return {
        templateId: this.getTemplateId,
        ...params,
      };
    },
    editAction(item) {
      this.saveTemplateProduto(item);
      this.navigateTo(
        this.editRoute,
        {
          id: item.id,
        },
      )
        .catch(() => {});
    },
    saveTemplateProduto(item) {
      this.setSessionItem(
        'produtoServicoIntegrador',
        item.produtoServicoIntegrador,
      );
    },
  },
};
</script>
